import { useEffect } from 'react';
import { LocationType, useFrontendSubscriptionStatus } from '@cmctechnology/webinvest-store-frontend';
import { useDispatch, useSelector } from 'react-redux';
import { MESSAGES_STORE_NAME, MessagesStore, defaultMessagesStore } from './Store';
import { MESSAGE_API_NAMES, messageActions } from './index';

type IStore = ReturnType<typeof MessagesStore.getState>;

export const useUnreadMessageCount = (location: LocationType) => {
  const dispatch = useDispatch();
  const count = useSelector((store: IStore) => store[MESSAGES_STORE_NAME].unreadMessages.count);

  const { polling, error, fetching } = useFrontendSubscriptionStatus(MESSAGES_STORE_NAME, MESSAGE_API_NAMES.UnreadMessageCount1);

  useEffect(() => {
    dispatch<any>(messageActions.subscribeUnreadMessageCount(location));
    return () => {
      dispatch<any>(messageActions.unsubscribeUnreadMessageCount(location));
    };
  }, []);

  return {
    loading: fetching && count === defaultMessagesStore.unreadMessages.count,
    polling,
    error,
    data: count,
    fetching
  };
};

export const usePlatformMessages = (location: LocationType, displayUrl?: string) => {
  const dispatch = useDispatch();
  const platformMessages = useSelector((store: IStore) => store[MESSAGES_STORE_NAME].platformMessages);

  const { polling, error, fetching } = useFrontendSubscriptionStatus(MESSAGES_STORE_NAME, MESSAGE_API_NAMES.PlatformMessageGetLatest1);

  useEffect(() => {
    dispatch<any>(messageActions.subscribePlatformMessages(location, displayUrl));
    return () => {
      dispatch<any>(messageActions.unsubscribePlatformMessages(location));
    };
  }, []);

  return {
    polling,
    error,
    data: platformMessages,
    fetching
  };
};
